<template>
  <el-table
    :ref="config.tableName"
    v-loading="config.loading"
    :element-loading-text="config.loadtext"
    :data="treeTableData"
    border
    height="80vh"
    style="width: 100%;margin-bottom: 20px;"
    :row-class-name="tableRowClassName"
    :cell-class-name="tableCellClassName"
    :row-key="rowKeyFunc"
    :select-on-indeterminate="false"
    :default-expand-all="true"
    :expand-row-keys="expandArray"
    highlight-current-row
    :header-cell-style="headerStyles"
    :cell-style="cellStyles"
    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    @select="select"
    @select-all="selectAll"
    @selection-change="selectionChange"
    @current-change="handleCurrentChange"
    @cell-click="openDialog"
    @cell-dblclick="cellDbclick"
    @row-contextmenu="rightClick"
    @row-click="clickTableRow"
    @header-click="headClick"

  >
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>




    <el-table-column
      v-for="(item,index) in treeTableLabel"
      v-if="!(item.isShow || item.isShow === 'false')"
      :key="index + config.tableId"
      :label="item.label"
      :prop="item.prop"
      :type="item.type"
      :width="item.width ? item.width : ''"
      :align="item.align ? item.align : 'center'"
      :formatter="formatCol"
      show-overflow-tooltip
      header-align="center"
    >

      <!-- eslint-disable-next-line -->
      <template slot-scope="scope">

        <!--父级文件夹样式-->
        <svg v-if="scope.row.wbsflag === '1' && item.prop === 'name' && scope.row.parentiid === '-1'" class="icon" aria-hidden="true">
          <use xlink:href="#icon-wenjianjia1"></use>
        </svg>
        <svg v-else-if=" scope.row.wbsflag === '1' && item.prop === 'name' && scope.row.parentiid !== '-1'" class="icon" aria-hidden="true">
          <use xlink:href="#icon-wenjian1"></use>
        </svg>
        <!--列文字样式-->
        <span v-if="item.click && scope.row[item.prop] && scope.row.id !=='wzyb66666666666666' && scope.row.id !== tabClickIndex" style="margin-left: 10px; color: #3A71A8">{{ scope.row[item.prop] }}</span>
        <!-- 新增行           -->
        <span v-else-if="item.prop === 'name' && scope.row.id ==='wzyb66666666666666'">
          <el-input ref="addInput" v-model="scope.row[item.prop]" v-focus autofocus="autofocus" size="mini" style="width: 60%" @blur="onInputBlur"></el-input>
        </span>
        <!--        <el-link v-if="item.click && scope.row.id" style="margin-left: 10px; color: #3A71A8">{{ scope.row[item.prop] }}</el-link>-->
        <span v-else-if="scope.row.id && scope.row.id === tabClickIndex && tabClickLabel === item.label">
          <!--          <el-input v-model="scope.row[item.prop] " maxlength="300" placeholder="请输入备注" size="mini" @blur="inputBlur" />-->
          <el-date-picker
            v-if="item.type === 'Date'"
            v-model="scope.row[item.prop]"
            align="right"
            :editable="false"
            :clearable="false"
            value-format="yyyy-MM-dd"
            type="date"
            class="colDate"
            placeholder="选择日期"
            size="mini"
            :picker-options="pickerColOptions"
            @change="dateColChangeEvent"
            @blur="dateInputBlur">
          </el-date-picker>
          <el-select v-else-if="item.type === 'Select'" v-model="scope.row[item.prop]" size="mini" clearable placeholder="请选择" @blur="dateInputBlur">
            <el-option
              v-for="selectItem in item.options"
              :key="selectItem.value"
              :label="selectItem.label"
              :value="selectItem.value">
            </el-option>
          </el-select>
          <el-input
            v-else
            v-model="scope.row[item.prop]"
            size="mini"
            clearable
            prefix-icon="el-icon-search"
            style="line-height: 24px;"
            @blur="dateInputBlur"
          ></el-input>
        </span>
        <span v-else-if="item.prop === 'iscritical'">
          <el-switch
            v-model="scope.row[item.prop]"
            active-color="#13ce66"
            inactive-color="#DCDFE6"
            @change="changeIscritical($event, scope.row)"
          >
          </el-switch>
        </span>
        <span v-else>{{ scope.row[item.prop] }}</span>
      </template>

    </el-table-column>
  </el-table>
</template>

<script>
/* eslint-disable */
export default {
  name: 'templateTreeTable',
  props: {
    pickerColOptions: {},
    expandArray: Array,
    treeTableLabel: Array,
    treeTableData: Array,
    config: Object,
    tabClickIndex: {
      String,
      default: null
    },
    tabClickLabel: {
      String,
      default: ''
    }
  },
  directives: {
    //input 自动获取焦点
    focus: {
      // 指令的定义
      inserted: function(el) {
        el.children[0].focus()
        // el.querySelector("input").focus();
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    changeIscritical($event, row) {
      this.$emit('changeIscritical', $event, row)
    },
    onInputBlur(e) {
      this.$emit('onInputBlur', e)
    },
    dateColChangeEvent(row, event, column) {
      this.$emit('dateColChangeEvent', row, event, column)
    },
    dateInputBlur(row, event, column) {
      this.$emit('dateInputBlur', row, event, column)
    },
    treeLoad(tree, treeNode, resolve) {
      this.$emit('treeLoad', tree, treeNode, resolve)
    },
    rowKeyFunc (row) {
      if (row.id) {
        return row.id
      } else {
        return row.name
      }
    },
    rightClick(row, column, event) {
      this.$emit('rightClick', row, column, event)
    },
    clickTableRow(row, column, event) {
      this.$emit('clickTableRow', row, column, event)
    },
    headClick(column, event) {
      this.$emit('headClick', column, event)
    },
    clearSearch() {
      this.$emit('clearSearch')
    },
    searchTable() {
      this.$emit('searchTable')
    },
    dateChangeEvent() {
      this.$emit('dateChangeEvent')
    },
    selectChangeEvent() {
      this.$emit('selectChangeEvent')
    },
    cellDbclick(row, column, cell, event) {
      this.$emit('cellDbclick', row, column, cell, event)
    },
    openDialog (row, column, cell, event) {
      this.$emit('openDialog', row, column, cell, event)
    },
    handleCurrentChange(currentRow) {
      this.$emit('handleCurrentChange', currentRow)
    },
    formatCol(row, column) {
      let str = ''
      this.$emit('formatCol', { row, column }, val => {
        str = val
      })

      return str
    },
    //设置行颜色
    tableRowClassName({ row, rowIndex }) {
      let str = ''
      this.$emit('tableRowClassName', { row, rowIndex }, val => {
        str = val
      })

      return str
    },
    tableCellClassName({ row, column, rowIndex }) {
      let str = ''
      this.$emit('tableCellClassName', { row, rowIndex }, val => {
        str = val
      })

      return str
    },
    // 表头行高与字体
    headerStyles() {
      let data = {}
      this.$emit('headerStyles', {}, val => {
        data = val
      })
      return data
    },
    // 内容行高与字体
    cellStyles() {
      let data = {}
      this.$emit('cellStyles', {}, val => {
        data = val
      })
      return data
    },
    select(selection, row) {
      this.$emit('select', selection, row)
    },
    selectAll(selection) {
      this.$emit('selectAll', selection)
    },
    selectionChange(selection) {
      this.$emit('selectionChange', selection)
    }
  }
}
</script>

<style  scoped  lang="scss">
  ::v-deep table.el-table__header thead.has-gutter tr th {
  height: 40px!important;
}
  .el-table  ::v-deep .warning-row {
    background: #99CCCC !important;
  }
  .el-table  ::v-deep  .select-row {
    background: #fbec88;
  }
  .el-table  ::v-deep .unselect-row {
    background: #fff !important;
  }
  .box-table tbody .cell{
    max-height: 10px;
  }


  /*表格鼠标悬停的样式（背景颜色）*/
  .el-table__body tr .hover-row > td {
    background-color: #f9e56d !important;
  }
  /*选中当前行的颜色*/
  /*.el-table__body tr.current-row > td {*/
  /*  background-color: #fbec88;*/
  /*}*/

  /* el-divider 修改高度、效果 */
  .el-divider--horizontal{
    margin: 3px 0;
    border-top: 1px dashed #e8eaec;
  }


  ::v-deep .button-size {
    height: 28px;
    float: left;
    line-height: 0px;
    align-items: center;
    justify-content: center;
  }
  ::v-deep .el-button--mini, .el-button--mini.is-round {
    padding: 7px 9px;
  }
  /*更改字号*/
  .el-table {
    font-size: 12px;
    color: #606266;
  }
  /*缩小表格间距*/
  .el-table ::v-deep.cell {
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap;
    word-break: break-all;
    line-height: 12px;
    padding-right: 10px;
  }
  .el-table th>.cell{
    display: inline-block;
    white-space: nowrap;
    word-break: keep-all;
    text-overflow: unset;
  }

  .el-link {
    display: inline;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
    text-decoration: none;
    outline: 0;
    padding: 0;
  }
  ::v-deep .el-link {
    font-weight: 500;
    font-size: 12px;
  }
  ::v-deep.bluecell{
    color: #3A71A8;
  }
  .el-link.el-link--default:hover {
    color: #409EFF;
    text-decoration: underline;
  }
.colDate {
  width: auto;
}
  .icon {
    width: 1.5em;
    height: 1.5em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
</style>
